module.exports = __webpack_public_path__ + "img/icon-success.67827b74.svg";